import { getWidth } from 'redux-window';

export const isTablet = theme => state => getWidth(state) < theme.breakpoint_lg;
export const isMobile = theme => state => getWidth(state) < theme.breakpoint_sm;
